import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from '../components/ProtectedRoute';
import MasterTab from '../pages/component-overview/MasterTab';
import InspectionList from '../pages/component-overview/InspectionList';
import UserList from '../pages/component-overview/UserList';
// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const ContactAdminPage = Loadable(lazy(() => import('pages/extra-pages/contact-admin')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const ModalConfirm = Loadable(lazy(() => import('pages/component-overview/ModalConfirm')));
//const InpectionList = Loadable(lazy(() => import('../pages/component-overview/InpectionList')));

// ==============================|| MAIN ROUTING ||============================== //
const withProtection = (element) => <ProtectedRoute>{element}</ProtectedRoute>;
const MainRoutes = {
  path: '/dashboard',
  element: withProtection(<DashboardLayout />), // 👈 Wrap with layout
  children: [
    {
      path: '',
      element: <DashboardDefault />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <ModalConfirm />
    },
    {
      path: 'inspection-list',
      element: <InspectionList />
    },
    {
      path: 'master-tab',
      element: <MasterTab />
    },
    {
      path: 'master-tab/:id',
      element: <MasterTab />
    },
    {
      path: 'users',
      element: <UserList />
    },
    {
      path: 'contact-admin',
      element: <ContactAdminPage />
    }
  ]
};

// const UserRoutes = {
//   path: '/users',
//   element: withProtection(<UserList />), // 👈 Wrap with layout
//   children: [   
//     {
//       path: '/',
//       element: <UserList />
//     }
//   ]
// };

export default MainRoutes;
